/**
 * Format a timestamp into "YYYY-MM-DD / HH:mm" format.
 *
 * @param {string | number | Date} timestamp - A valid date string, number, or Date object.
 * @param {string} [fallback="--"] - Fallback value if the timestamp is invalid or missing.
 * @returns {string} Formatted string like "2025-03-09 / 09:28" or fallback.
 */
const formatDateAndTime = (timestamp, fallback = "-") => {
  if (!timestamp) return fallback;

  const dateObj = new Date(timestamp);
  if (isNaN(dateObj)) return fallback;

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} / ${hours}:${minutes}`;
};

export default formatDateAndTime;
